module.exports = __webpack_public_path__ + "img/arrow-up.b380d955.svg";